import { render, staticRenderFns } from "./AdmissionManagement.vue?vue&type=template&id=3588e075&scoped=true"
import script from "./AdmissionManagement.vue?vue&type=script&lang=js"
export * from "./AdmissionManagement.vue?vue&type=script&lang=js"
import style0 from "./AdmissionManagement.vue?vue&type=style&index=0&id=3588e075&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588e075",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3588e075')) {
      api.createRecord('3588e075', component.options)
    } else {
      api.reload('3588e075', component.options)
    }
    module.hot.accept("./AdmissionManagement.vue?vue&type=template&id=3588e075&scoped=true", function () {
      api.rerender('3588e075', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/AdmissionManagement.vue"
export default component.exports